var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart-card',{attrs:{"size":_vm.size,"title":"종사자 현황","value":_vm.data,"unit":"명","init-total":_vm.total,"isMoveWrite":_vm.isMoveWrite,"is-move-detail":false,"orientation":_vm.orientation},on:{"detail":_vm.onClickDetail,"write":_vm.onClickWrite}})
}
var staticRenderFns = []

export { render, staticRenderFns }